import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Logo: React.FC = () => {
  return (
    <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none', color: 'white' }}>
      <motion.div
        whileHover={{ rotate: [0, -5, 5, 0] }}
        transition={{ duration: 0.5 }}
        style={{
          width: '42px',
          height: '42px',
          background: 'var(--gradient-logo)',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          boxShadow: '0 4px 15px var(--accent-primary-border)',
        }}
      >
        <span style={{
          fontSize: '11px',
          fontWeight: '900',
          color: 'white',
          writingMode: 'vertical-rl' as const,
          textOrientation: 'mixed' as const,
          letterSpacing: '2px',
          fontFamily: "'Space Grotesk', sans-serif",
        }}>
          ALL
        </span>
      </motion.div>
      <div style={{ display: 'flex', flexDirection: 'column' as const, lineHeight: 1 }}>
        <span style={{
          fontSize: '24px',
          fontWeight: '800',
          letterSpacing: '1px',
          fontFamily: "'Space Grotesk', 'Inter', sans-serif",
          background: 'linear-gradient(135deg, #ffffff 0%, #94a3b8 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}>
          ONE
        </span>
        <span style={{
          fontSize: '11px',
          fontWeight: '600',
          color: '#64748b',
          letterSpacing: '3px',
          marginTop: '1px',
        }}>
          TOPLULUĞU
        </span>
      </div>
    </Link>
  );
};

export default Logo;
